module.exports = __webpack_public_path__ + "static/media/onboarding3.7dce9cba.svg";